module.exports = __webpack_public_path__ + "static/img/at_2.14befd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/at_2.jpg
// module id = /CfO
// module chunks = 1